export default __webpack_public_path__ + "static/media/felt_buddy.376f3dc4.png";